import BaseResource from './index'

export default class LauncherChallengeResource extends BaseResource {
    static endpoint = '/users/launcher/challenges'

    async confirm(code) {
        const result = await this.wrap('/confirm').post({ code })
        return result.data
    }

    get currentStatus() {
        return this.attributes.current_status || this.attributes.status
    }
}
